module.exports = __webpack_public_path__ + "static/media/set.4d56d3cb.png";